<script>
export default {
  name: 'ColumnLayout',
  description: 'Column-aware implementation of a `v-for` loop.',
  props: {
    columns: {
      type: Number,
      default: 3
    },
    tag: {
      type: String,
      default: 'div'
    },
    value: {
      type: Array,
      required: true
    }
  },
  computed: {
    iterable () {
      return this.value.reduce((result, item, index) => {
        const column = index % this.columns
        result[column] = result[column] || []
        result[column].push(item)
        return result
      }, [])
    }
  }
}
</script>

<template>
  <VContainer
    v-bind="$attrs"
    fluid
    pa-0
  >
    <VLayout>
      <VFlex
        v-for="column in columns"
        :key="[_uid, 'c' + column].join('.')"
        :class="`xs${12 / columns}`"
        :tag="tag"
      >
        <slot
          v-if="$slots.prepend && column == 1"
          name="prepend"
        />

        <slot
          v-for="(item, index) in iterable[column - 1]"
          :item="item"
          :_uid="[_uid, 'c' + column, 'r' + index].join('.')"
        />

        <slot
          v-if="$slots.append && column == columns"
          name="append"
        />
      </VFlex>
    </VLayout>
  </VContainer>
</template>
